import React from 'react';
import { Eyebrow } from './Eyebrow';
import { Reveal } from './Reveal';
const pains = ['TOMÁS PROTEÍNA Y TE CAE PESADA.', 'PREPARÁS UN SHAKE Y TE QUEDA EL LÍO DEL BLENDER EN LA PILETA.', 'BUSCÁS ALGO RICO QUE NO SEA "POSTRE CON CULPA".'];
export function Agitation() {
  return <section className="bg-cream pb-16 pt-20 text-ink" data-id="element-13">
      <div className="mx-auto max-w-[1100px] px-6" data-id="element-14">
        <Reveal data-id="element-15">
          <Eyebrow tone="dark" data-id="element-16">¿TE PASA ESTO?</Eyebrow>
        </Reveal>
        <div className="mt-[26px] flex flex-col" data-id="element-17">
          {pains.map((pain, i) => <Reveal key={i} className={`max-w-[780px] border-b border-ink/[0.18] py-[18px] font-display text-[clamp(20px,3.2vw,32px)] normal-case tracking-normal ${i === 0 ? 'border-t' : ''}`} data-id="element-18">
              {pain}
            </Reveal>)}
        </div>
        <Reveal className="mt-[26px] max-w-[560px] text-[15px] font-semibold text-ink/70" data-id="element-19">
          Y al final, terminás tomando lo de siempre. Sin proteína, otra vez.
        </Reveal>
      </div>
    </section>;
}